// extracted by mini-css-extract-plugin
var _1 = "CalendarTaskRequestLink-modulelabel__v59bW Field-modulelabel__b72si";
var _2 = "CalendarTaskRequestLink-modulelink__dcihv Link-modulelink__btW0L";
export { _1 as "label", _2 as "link" }
